export function browserWindowFactory() {
  return window;
}
